import React from 'react';
import type { components } from '../../../../types/learnerApi';

type Config = components['schemas']['SanitizedCompletionConfig'];

export interface FillBlankAnswer {
  answers: Record<string, string>;
}

export interface CompletionFillBlankViewProps {
  item: { id: string; points?: number; config: Config };
  mode: 'learner' | 'preview';
  value?: FillBlankAnswer;
  onChange?: (value: FillBlankAnswer) => void;
  disabled?: boolean;
}

const CompletionFillBlankView: React.FC<CompletionFillBlankViewProps> = ({
  item,
  mode,
  value,
  onChange,
  disabled,
}) => {
  const answers = value?.answers ?? {};

  const handleChange = (blankId: string, text: string) => {
    if (disabled || mode === 'preview') return;
    onChange?.({ answers: { ...answers, [blankId]: text } });
  };

  // Split prompt on ___ and interleave inputs keyed by blanks[i].id
  const parts = item.config.prompt.split('___');

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-baseline gap-y-2 text-text-primary leading-loose">
        {parts.map((part, i) => (
          <React.Fragment key={i}>
            <span>{part}</span>
            {i < item.config.blanks.length && (
              <input
                type="text"
                value={answers[item.config.blanks[i].id] ?? ''}
                onChange={(e) => handleChange(item.config.blanks[i].id, e.target.value)}
                disabled={disabled}
                aria-label={`Blank ${i + 1}`}
                className="inline-block mx-1 px-2 py-0.5 min-w-24 w-32 rounded border-b-2 border-primary-500 bg-transparent text-text-primary text-sm focus:outline-none focus:border-primary-700 dark:focus:border-primary-300 disabled:opacity-60"
              />
            )}
          </React.Fragment>
        ))}
      </div>
      {item.points != null && (
        <p className="text-xs text-text-tertiary">{item.points} pt{item.points !== 1 ? 's' : ''}</p>
      )}
    </div>
  );
};

export default CompletionFillBlankView;
